import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import getClient from '../lib/get-contentful-client.js';
import { storeState } from '../lib/store-state.js';
import { IconContext } from "react-icons";
import { IoIosMail } from "react-icons/io";


import { Card, CardHeader } from './card.js';
import { Spinner } from './loading.js';

import {logo} from '../components/me.png';
import './card.css';
import { relative } from 'path';

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = props.initialState || {
      error: null,
      isLoaded: false,
      items: []
    };

    // needed for react-snap
    window.snapSaveState = () => {
      storeState(this.state);
    };
  }

  componentDidMount() {
    this.state.isLoaded ||
      getClient(process.env)
        .getEntries({
          content_type: 'post'
        })
        .then(({ items }) => {
          this.setState({
            categories: this.getCategories(items),
            isLoaded: true
          });
        })
        .catch(error => {
          this.setState({
            error,
            isLoaded: true
          });
        });
  }

  getCategories(items) {
    return items.reduce((acc, item) => {
      const category = item.fields.category;
      const categorySlug = category.fields.slug;
      if (!acc[categorySlug]) {
        acc[categorySlug] = { category, posts: [] };
      }

      acc[categorySlug].posts.push(item);
      return acc;
    }, {});
  }

  render() {
    const { error, categories, isLoaded } = this.state;
    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <Spinner />;
    } else {
      return (
        <div>
          <Helmet>
            <title>Priyanshu Madan | Home</title>
          </Helmet>
         

          
            {/* <h2>What is this?</h2> */}
            <div style={{ display: "flex", flexDirection: "row",marginTop: "50px"}}>
              <div style={{ width: "20%" }}>
                <img src={require('./pissi.jpg')} alt="Logo"  />
              </div>
              <div style={{ verticalAlign:"center", width: "70%", display: "inline-block" ,marginLeft: "50px"}}>
                <h1>Hi I'm Priyanshu </h1>
                <h3>
                I am an aspiring data scientist with a passion for problem solving story telling through data and videos. 
                I am currently pursuing my Masters in Information Management at University of Illinois at Urbana-Champaign and have a background in
                Computer Science Engineering from SRM University, India. </h3>

                 <br></br>

                 <i>This wesbite is built in React and Contentful</i>
                 
                 {/* <h3>My Skills</h3>
                 <div style={{backgroundColor:"#2d9dbc"}}>
                 <Card><img src={require('./r_logo.png')} alt="Logo" height="30px" margin="" /></Card>
                 <IconContext.Provider value={{ color: "grey", size:"3em" }}> </IconContext.Provider>
            </div> */}
            </div>
            </div>


            {/* <p>
             This is where i explain who I am
            </p> */}
          

          <h2 className="centered">Learnings</h2>
          <ul className="o-grid">
            {Object.entries(categories).map(
              ([categorySlug, { category, posts }]) => (
                <li key={categorySlug}>
                  <Card>
                    <CardHeader className={`o-gradient-${categorySlug}`}>
                      {category.fields.title}
                      <img
                        aria-hidden="true"
                        src={category.fields.icon.fields.file.url}
                        alt=""
                      />
                    </CardHeader>
                    <ul>
                      {posts.map(({ sys, fields }) => (
                        <li key={sys.id}>
                          <Link to={`/posts/${fields.slug}/`}>
                            {fields.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                    <br />
                  </Card>
                </li>
              )
            )}
          </ul>
        </div>
      );
    }
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/home.js